import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import get from 'lodash/get';
import startsWith from 'lodash/startsWith';
import InlineMessage from '../InlineMessage';

class ImageLoader extends React.Component {
  state = { isExternalUrl: false, imageStatus: 'loading' };

  componentDidMount() {
    const isExternalUrl = startsWith(this.props.src, 'http');
    this.setState({ isExternalUrl });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.src !== this.props.src) {
      const isExternalUrl = startsWith(nextProps.src, 'http');
      this.setState({ isExternalUrl });
    }
  }

  getImageUrl = responseUrl => {
    const isExternalUrl = startsWith(responseUrl, 'http') || startsWith(responseUrl, 'data:image');
    return isExternalUrl ? responseUrl : `${process.env.REACT_APP_IMAGE_LOCATION}${responseUrl}`;
  };

  contentLoader = () => [
    <img
      key={4}
      style={{ display: 'none' }}
      src={this.getImageUrl(this.props.src)}
      alt={get(this.props, 'alt', '')}
      onLoad={this.handleImageLoaded}
      onError={this.handleImageErrored}
    />,
    <Spin key={5} spinning>
      <div
        style={{
          width: get(this.props, 'style.width', 150),
          height: get(this.props, 'style.height', 100),
        }}
      />
    </Spin>,
  ];

  handleImageErrored = () => {
    this.setState({ imageStatus: 'failed' });
  };

  handleImageLoaded = () => {
    this.setState({ imageStatus: 'loaded' });
  };

  render() {
    return (
      <div style={this.props.style}>
        {this.state.imageStatus === 'failed' ? (
          <InlineMessage type="error" message="No Image" />
        ) : null}
        {this.state.imageStatus === 'loading' ? this.contentLoader() : null}
        {this.state.imageStatus === 'loaded' ? (
          <img
            {...this.props}
            style={{ maxWidth: '100%' }}
            alt={get(this.props, 'alt', '')}
            src={this.getImageUrl(this.props.src)}
          />
        ) : null}
      </div>
    );
  }
}

ImageLoader.propTypes = {
  src: PropTypes.string.isRequired,
};

export default ImageLoader;
